import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKey as useUserKey } from 'shared/hooks/queries/use-user-query';
import {
  getEmailByOobcode,
  resetPassword,
  signInUser,
  signOutUser,
} from 'shared/services/backend-api';

export const useResetPasswordMutation = () => {
  const client = useQueryClient();

  return useMutation<
    void,
    unknown,
    {
      password: string;
      code: string;
    }
  >({
    mutationFn: async ({ password, code }) => {
      // get email from the oobCode
      const email = await getEmailByOobcode(code);
      // sign out user before resetting the password to prevent problems with a potential logged-in user
      await signOutUser();
      // reset password
      await resetPassword(code, password);
      // The password has changed now, so a failed login lands on /login instead of failing the reset.
      await signInUser(email, password).catch(() => null);
      // invalidate user
      await client.invalidateQueries({ queryKey: [useUserKey] });
    },
  });
};
